/* eslint-disable no-unused-vars */
import { ControllerModel } from "../_model/ControllerModel";
import { SingletonFlowchart } from "../_service/singletonFlowchart";
import { Liming } from "./modelLiming";

class ControllerLiming extends ControllerModel {
  constructor() {
    super("ControllerLiming");
    
    this.setNewNode = (callback) => {
      let _liming = new Liming();
      _liming.decorate(callback);

      this.addNode(_liming);
      SingletonFlowchart.SaveStatus();
    }

    this.loadNode = (node, callback) => {
      let _liming = new Liming();
      _liming.copyFrom(node);
      _liming.decorate(callback);
      this.addNode(_liming)
    }

    this.getProperties = async (node) => {
      let n = new Liming();
      await n.copyFrom(node);
      return n.data
    }

    this.getNode = (node) => {
      let n = new Liming();
      n.copyFrom(node);
      return n
    }
  }
}

export { ControllerLiming };
